import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-error-message',
  templateUrl: './error-message.component.html',
  styleUrls: ['./error-message.component.scss']
})
export class ErrorMessageComponent implements OnInit {
  private _message: string

  constructor() { }

  public ngOnInit() {
    this.clear()
  }

  public get message() {
    return this._message
  }

  public showDefault() {
    this.show('An unexpected error has occurred. Please contact techsupport@manhattanprep.com')
  }

  public show(message: string) {
    this._message = message
  }

  public clear() {
    this._message = '&nbsp;'
  }
}
